export const CONFIG_PATH = '/app-environment'
